export default "__VITE_ASSET__I8_ziehw__"